module.exports = __webpack_public_path__ + "static/assets/7d34702e6b8afb339d1f3e6fadf8b49a.svg";